import * as Yup from 'yup';

export const blogSubscriptionSchema = Yup.object({
    email: Yup.string().email('Email not valid').required('This field is required'),
});
